import { IDLE, LOADING } from "@constants";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getFromServerTopic, getFromServerTopic2 } from "@utility/slice";

const action = (name) => `curtailmentExp/${name}`;

// Capture Groups are $1: Date yyyy-mm-dd, $2: Time hh:mm or hh:mm:ss, $3: Milliseconds .vvv
export const reDateTime =
  /^([0-9]{4}-[0-9]{2}-[0-9]{2})[ T]?([0-9]{2}:[0-9]{2}(?::[0-9]{2})?)?(\.[0-9]{3})?Z?$/;

function resolveDate(value) {
  return value ? value?.replace(reDateTime, "$1T$2") : value;
}

export const formatDateTime = function (
  format = "Y-m-d H:i:s",
  timestamp = null,
) {
  const dt = timestamp === null ? new Date() : new Date(timestamp);
  format = format ? format : "Y-m-d H:i:s";
  return format
    .replace(/Y/g, dt.getFullYear())
    .replace(/m/g, `00${dt.getMonth() + 1}`.slice(-2))
    .replace(/d/g, `00${dt.getDate()}`.slice(-2))
    .replace(/H/g, `00${dt.getHours()}`.slice(-2))
    .replace(/i/g, `00${dt.getMinutes()}`.slice(-2))
    .replace(/s/g, `00${dt.getSeconds()}`.slice(-2))
    .replace(/v/g, `000${dt.getMilliseconds()}`.slice(-3));
};

export const callServer = createAsyncThunk(
  action("callServer"),
  (payload, { getState }) => {
    const state = getState();

    // Simulating using axios to hit server or something
    return new Promise((resolve) => {
      setTimeout(resolve, 1000, {
        response: {
          payload: `${state.curtailmentExp.display}${payload}`,
        },
      });
    });
  },
);

export const getFromServer = (action, payloadFn) => {
  return getFromServerTopic({ topic: "curtailment", action, payloadFn });
};
export const getFromServer2 = (name, payloadFn, thunkOptions) => {
  return getFromServerTopic2("curtailment", name, payloadFn, thunkOptions);
};

const getProgramsForDropdown = getFromServer2(
  "getProgramsForDropdown",
  undefined,
  {
    condition: (arg, { getState }) => {
      const state = getState().curtailmentExp;
      return state?.programs?.length === 0;
    },
  },
);

const getEventDaysForDropdown = getFromServer2("getEventDaysForDropdown");

export const initializeCurtailmentExp = createAsyncThunk(
  action("initialize"),
  async (arg, { dispatch }) => {
    //console.log(arg);
    return Promise.all([
      dispatch(getProgramsForDropdown()),
      dispatch(getEventDaysForDropdown()),
    ]);
  },
);

export const getLexicon = getFromServer(
  "getLexiconByEventId",
  async (payload /*{ getState }*/) => {
    //const state = getState();
    //console.log("getLexicon", payload, state.lexicon);
    return payload;
  },
);

export const getCurtailmentPlan = getFromServer2(
  "readCurrentCurtailPlanBySiteIdAndProgramId",
  //"readCurrentCurtailPlansBySiteId",
  async (payload /*, { getState }*/) => {
    //const state = getState().curtailmentExp;
    //console.log("getCurtailmentPlan", payload, state.curtailPlan);
    //if (!state.curtailPlan?.[payload.binds.siteId]) {
    return payload;
    //}
  },
);

/*
const loadLexicon = (obj, lex) => {
  // row is a flat object which needs to be given depth
  // and lex is where we store that depth
  Object.keys(obj).forEach(function (key) {
    const c = key.split("_"); // Split the hierarchy into separate names to traverse the lexicon
    let L = lex;
    for (let i = 0; i < c.length; i++) {
      if (L?.[c[i]] === undefined) {
        if (i + 1 === c.length) {
          //L[c[i]] = isDate(obj[key]) ? dateToObj(obj[key]) : obj[key];
          //L[c[i]] = lexMorph(obj[key], c[i]);
          L[c[i]] = obj[key]; // Use this for now until the mysql field info can be pulled down
          break;
        }
        L[c[i]] = {};
      }
      L = L[c[i]]; // Move to the next level of the lexicon
    }
    //L = obj[key];
  });
};
 */

export const compareTableOpts = (opts1, opts2) => {
  //console.log(JSON.stringify(opts1), JSON.stringify(opts2));
  return JSON.stringify(opts1) === JSON.stringify(opts2);
};

export const slice = createSlice({
  name: "curtailmentExp",
  initialState: {
    display: "",
    status: IDLE,
    safeMode: true,
    displayOrganization: false,
    areaTypes: null,
    programAdmins: null,
    programs: [],
    eventDays: [],
    eventDateTime: null,
    tableOpts: {
      curtail: { filters: [], sortB: [], hiddenColumns: ["name"] },
    },
    trainingMode: false,
    trainingOpts: {
      programId: null,
      subCool: 1,
      eventDate: null,
      startTime: "11:00",
      endTime: "15:00",
    },
    curtailPlan: {},
    /*
	curtailPlan: {
      id: null,
      siteId: null,
      programId: 0,
      planText: ``,
      dateCreated: null,
      effectiveStart: null,
      effectiveEnd: null,
    },
	*/
    lexicon: null,
  },
  reducers: {
    changeDisplay: (state, action) => {
      state.display = action.payload;
    },
    changeSafeMode: (state, action) => {
      //console.log("changeSafeMode", action.payload);
      state.safeMode = action.payload;
    },
    changeDisplayOrganization: (state, action) => {
      //console.log("changeDisplayOrganization", action.payload);
      state.displayOrganization = action.payload;
    },
    changeTrainingMode: (state, action) => {
      state.trainingMode = action.payload;
    },
    changeTrainingOptsField: (state, action) => {
      const { name, value } = action.payload;
      state.trainingOpts = { ...state.trainingOpts, [name]: value };
    },
    setEventDateTime: (state, action) => {
      state.eventDateTime = action.payload;
    },
    changeTrainingOpts: (state, action) => {
      state.trainingOpts = action.payload;
    },
    lexIt: (state, action) => {
      //str, objLexicon = lexicon) {
      const str = action.payload;
      const objLexicon = state.lexicon;
      state.display = !objLexicon
        ? str
        : str.replace(
            /\${([^\}]+)}/g,
            (match, capture /*offset, string, groups*/) => {
              const c = capture.split("."); // Split the hierarchy into separate names to traverse the lexicon
              let lex = objLexicon; // Grab a reference to the lexicon
              for (let i = 0; i < c.length; i++) {
                lex = lex[c[i]]; // Move to the next level of the lexicon
              }
              return typeof lex === "function" ? lex() : lex; // Return the value at the specified name
            },
          );
    },
    setTableOpts: (state, action) => {
      const { tableName, options } = action.payload;
      state.tableOpts[tableName] = {
        ...(state.tableOpts?.[tableName] ?? {
          filters: [],
          sortBy: [],
          hiddenColumns: [],
        }),
        ...options,
      };
      //state.tableOpts[tableName].filters = options.filters;
      //state.tableOpts[tableName].sortBy = options.sortBy;
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(getProgramsForDropdown.fulfilled, (state, action) => {
        //console.log("getProgramsForDropdown.fullfilled", state, action);
        if (action?.payload?.rc === "OK") {
          state.programs = action.payload.payload;
        } else {
          console.error("ERROR", action?.payload?.context?.sysMessages);
        }
      })
      .addCase(getEventDaysForDropdown.fulfilled, (state, action) => {
        if (action?.payload?.rc === "OK") {
          const eventDays = action.payload.payload;
          eventDays.map((obj) => {
            obj.value = resolveDate(obj.value);
            //obj.label = formatDateTime("Y-m-d", obj.label);
          });

          state.eventDays = eventDays;
        } else {
          console.error("ERROR", action?.payload?.context?.sysMessages);
        }
      })
      .addCase(callServer.pending, (state) => {
        state.status = LOADING;
      })
      .addCase(callServer.fulfilled, (state, action) => {
        state.display = action.payload.response.payload;
        state.status = IDLE;
      })
      //.addCase(getLexicon.pending, (state, action) => {
      //console.log("getLexicon.pending", state, action);
      //pendingRequest(state, LOADING);
      //})
      .addCase(getLexicon.fulfilled, (state, action) => {
        //console.log("getLexicon.fulfilled state", state);
        //console.log("getLexicon.fulfilled action", action);
        //const myLex = {};
        //loadLexicon(action.payload, myLex);
        //state.lexicon = myLex;
        state.lexicon = action.payload.response;
        //completedRequest(state);
      })
      .addCase(getLexicon.rejected, (state, action) => {
        console.log("getLexicon.rejected state", state);
        console.log("getLexicon.rejected action", action);
        //rejectedRequest(state);
      })
      //.addCase(getCurtailmentPlan.pending, (state, action) => {
      //console.log("getCurtailmentPlan.pending", state, action);
      //})
      .addCase(getCurtailmentPlan.fulfilled, (state, action) => {
        //console.log("getCurtailmentPlan.fulfilled state", state);
        //console.log("getCurtailmentPlan.fulfilled action", action);
        //console.log("action.payload.response", action.payload.response);
        // state.curtailPlan[action.payload.response?.[0]?.siteId]
        if (action?.payload?.rc === "OK") {
          const plans = {};
          const plan = action.payload.payload;
          if (plan) {
            plans[plan?.programId] = plan;
            state.curtailPlan[plan?.siteId] = {
              ...(state.curtailPlan?.[plan?.siteId] || {}),
              ...plans,
            };
          }
        } else {
          console.log("ERROR", action?.payload?.context?.sysMessages);
        }

        /*
        if (action.payload.response?.map) {
          const plans = {};
          action.payload.response.map((obj) => {
            plans[obj["programId"]] = obj;
          });
          //console.log("plans", plans);
          state.curtailPlan[action.payload.response?.[0].siteId] = plans;
          //console.log("curtailPlan", state.curtailPlan);
        }
        */
      })
      .addCase(getCurtailmentPlan.rejected, (state, action) => {
        console.log("getCurtailmentPlan.rejected state", state);
        console.log("getCurtailmentPlan.rejected action", action);
      });
  },
});

export const {
  changeDisplay,
  changeSafeMode,
  changeDisplayOrganization,
  changeTrainingMode,
  changeTrainingOpts,
  changeTrainingOptsField,
  lexIt,
  setTableOpts,
  setEventDateTime,
} = slice.actions;

export default slice.reducer;
